<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">在华紧急救援服务</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:39px;">在华紧急救援服务</h3>
      <h4 class="rescue-title">为何选择威马捷的在华救援服务</h4>
      <div class="img-box">
        <img :src="overseas2"
             alt="">
      </div>
      <h4 class="rescue-title">威马捷中国合作网络</h4>
      <p class="experience-para"
         style="margin-bottom:39px;">
        威马捷的24小时救援中心设立在北京市，同时在上海、大连、广州设有分公司。<br/> 通过威马捷的客服中心以及覆盖中国大陆及港澳台全域的合作网络为在华客户提供24小时的安心救援服务。
      </p>
      <div class="img-box">
        <img :src="overseas3"
             alt=""
             style="width:850px;">
      </div>
      <h4 class="rescue-title">医疗救援服务图解</h4>
      <div class="img-box">
        <img :src="overseas"
             alt=""
             style="width:929px;">
      </div>
      <h4 class="rescue-title">在华紧急救援服务内容</h4>
      <div class="personalized-list">
        <div class="personal-cell"
             v-for="(service,index) in services"
             :key="index">
          <h5>{{service.title}}</h5>
          <p>{{service.info}}</p>
        </div>
      </div>
      <a class="more-cases"
         @click="toGuide">&nbsp;&nbsp;医疗救援服务案例>></a>
    </div>
  </div>
</template>
<script>
import overseas from '@/assets/images/rescue/overseas-service.jpg'
import overseas2 from '@/assets/images/rescue/overseas-service4.jpg'
import overseas3 from '@/assets/images/rescue/overseas-service30.png'
export default {
  data () {
    return {
      overseas, overseas2, overseas3,
      services: [
        { title: '介绍医院及安排就医', info: '为在华客户介绍并安排最适合的医疗机构就诊。' },
        { title: '翻译服务', info: '为客户提供医疗翻译服务，协助与当地医护人员的无障碍有效沟通。' },
        { title: '治疗监护', info: '客户住院时，由威马捷顾问医生与当地主治医生取得联系，评估跟踪治疗情况。' },
        { title: '当地治疗评价及建议', info: '根据客户需求，由威马捷顾问医生就当地治疗情况作出医疗专业解析，并给出建议。' },
        { title: '紧急医疗转运', info: '如果当地医疗环境无法为客户提供所需治疗，我们将为患者提供紧急转运，重伤者将会根据情况安排患者在医护人员陪同下转运回国。' },
        { title: '遗体处理及转运', info: '客户在中国不幸身故时，协助家属处理相关手续。根据家属申请，安排遗体回国转运。' },
        { title: '亲属紧急探访协助', info: '客户住院期间，为家属紧急赴华提供出行建议及旅行援助。' },
        { title: '代垫医疗费及保险理赔手续', info: '在保险公司授权的情况下为客户代付治疗费，并协助客户取得理赔材料完成保险理赔手续。' },
        { title: '治疗费用管理', info: '通过威马捷的医疗网络，针对客户的高额治疗费用进行折扣申请，为客户及保险公司控制成本。' },
      ]
    }
  },
  methods: {
    toGuide () {
      localStorage.setItem('linkId', 'one')
      this.$router.push({
        path: '/rescueOfCustomerService'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.emergency-list {
  margin-left: 50px;
  li {
    list-style-type: initial;
    list-style-position: inside;
    font-size: 24px;
    color: #333130;
    line-height: 36px;
  }
}
.personalized-list {
  display: flex;
  width: 928px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  .personal-cell {
    width: 302px;
    height: 240px;
    border: 1px solid #e9ebf4;
    padding: 0;
    margin-bottom: 30px;
    h5 {
      font-size: 20px;
      color: #33312f;
      height: 60px;
      line-height: 60px;
      background: #e9ebf3;
      padding-left: 11px;
      margin-bottom: 0;
    }
    p {
      font-size: 16px;
      color: #33312f;
      line-height: 16px;
      line-height: 32px;
      padding: 18px 11px;
    }
  }
}
.img-box {
  width: 100%;
  img {
    display: block;
    width: 900px;
    margin: 0 auto 99px auto;
  }
}
.more-cases {
  display: inline-block;
  width: 217px;
  height: 38px;
  line-height: 38px;
  background: url('../assets/images/home/head-vip.jpg') no-repeat right;
  color: #fff;
  font-size: 20px;
  margin-bottom: 100px;
  cursor: pointer;
}
</style>